<div
    class="tw-relative tw-bg-no-repeat tw-bg-gradient-to-b tw-from-[#e6e6e6] tw-to-[#FFFFFF] sm:tw-bg-gradient-to-b sm:tw-from-[#e6e6e6] sm:tw-to-[#FFFFFF] xl:tw-bg-[url('assets/images/Bg.png')] tw-bg-[length:100%] tw-min-h-[100vh]"
>
    <header class="">
        <div
            class="tw-relative tw-flex tw-justify-center tw-pt-20 tw-min-h-[5rem] tw-w-full tw-px-[5vw] md:tw-px-[4vw]"
        >
            <div class="tw-flex tw-justify-center tw-items-center">
                <img
                    [routerLink]="'/home'"
                    src="/assets/images/logo/header_desktop.webp"
                    alt="logo"
                    class="tw-h-auto tw-w-[50%] lg:tw-w-[40%] sm:tw-w-[50%]"
                />
            </div>
        </div>
    </header>
    <div
        class="tw-flex tw-justify-center tw-gap-[6vw] md:tw-mt-[3rem] tw-mx-[2rem]"
    >
        <div class="tw-mt-20">
            <div
                class="tw-flex tw-flex-col md:tw-flex-row tw-items-center tw-gap-[2rem]"
            >
                <div
                    class="tw-min-h-[4rem] tw-min-w-[4rem] tw-rounded-full tw-bg-accent-light tw-flex tw-items-center tw-justify-center"
                >
                    <mat-icon class="check-icon">check</mat-icon>
                </div>
                <div
                    class="tw-flex tw-justify-center tw-flex-col tw-items-center md:tw-block"
                >
                    <div class="tw-text-[40px] tw-text-center md:tw-text-start">
                        {{ "RESET_PASSWORD.CHECK_EMAIL" | translate }}
                    </div>
                    <div
                        class="tw-mt-3 md:tw-mt-0 tw-text-gray-400 tw-text-center md:tw-text-start"
                    >
                        {{
                            "RESET_PASSWORD.CHECK_EMAIL_DESCRIPTION" | translate
                        }}
                    </div>
                </div>
            </div>

            <div class="tw-w-full md:tw-block tw-flex tw-justify-center">
                <button
                    class="tw-mt-10 tw-rounded-2xl tw-text-white tw-font-semibold tw-bg-[#e3d8c9] tw-bg-primary-orange-light tw-py-[1rem] tw-w-[90%] md:tw-w-[120%] access-btn"
                    (click)="goToResetPassword()"
                >
                    {{ "RESET_PASSWORD.GO_TO_RESET_PASSWORD" | translate }}
                </button>
            </div>

            <div class="tw-mt-7 tw-w-full tw-flex tw-justify-center">
                <div class="tw-text-gray-400">
                    {{ "RESET_PASSWORD.DIDNT_RECEIVE_THE_EMAIL" | translate }}
                </div>
                <div
                    class="tw-underline access-btn tw-ml-2"
                    (click)="onResendEmail()"
                >
                    {{ "RESET_PASSWORD.RESEND" | translate }}
                </div>
            </div>
        </div>
    </div>
</div>
